'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPin = function TiPin(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.9 7.1c-0.7-0.6-1.7-0.6-2.4 0-0.1 0.2-0.3 0.4-0.3 0.6-1.4 2.9-3 4.5-4.9 5.5-2.2 1.1-4.6 1.8-8.6 1.8-0.3 0-0.5 0-0.7 0.1-0.4 0.2-0.7 0.5-0.9 0.9-0.1 0.4-0.1 0.9 0 1.3 0.1 0.2 0.2 0.4 0.4 0.5l5.4 5.5-7.6 10 10.1-7.5 5.4 5.4c0.2 0.1 0.4 0.2 0.6 0.3 0.2 0.1 0.4 0.2 0.6 0.2s0.4-0.1 0.6-0.2c0.4-0.1 0.8-0.5 0.9-0.9 0.1-0.2 0.2-0.4 0.2-0.6 0-4 0.7-6.5 1.8-8.6 0.9-1.9 2.6-3.5 5.5-4.9 0.2 0 0.4-0.2 0.5-0.3 0.7-0.7 0.7-1.7 0-2.4l-6.6-6.7z' })
        )
    );
};

exports.default = TiPin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/pin.js
// module id = 3920
// module chunks = 0